@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.phoneCode {
  padding: 13px 0px 13px 16px;
  display: flex;
  align-items: center;
  gap: 18px;
  flex-shrink: 0;
  cursor: pointer;
}

.phoneCodeFlag {
  width: 24px;
  height: 16px;
  object-fit: cover;
  border-radius: 2px;
  flex-shrink: 0;
}

.phoneCodeInput {
  width: 36px;
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: transparent;
  color: v.$gray-light-color;
  @include t.text(14px, 22px, "normal");
  cursor: pointer;
}

.openListIcon {
  flex-shrink: 0;
  transition: transform 0.3s ease-in-out;
}

.openListIconActive {
  transform: rotate(180deg);
}

.loader {
  width: 80px;
}

/* Chinese Brothers */

.phoneCodeInputChineseBrothers {
  color: v.$white-color;
}